import { Chip, Stack, Tooltip } from "@mui/material";
import { useTranslate } from "@tolgee/react";

interface Props {
  /** 1-based position within the item's group. */
  position: number;
  notRanking: boolean;
  deleted: boolean;
}

/** Where an item stands in its group, and why it may not rank. */
export function PreferenceItemTags({ position, notRanking, deleted }: Props) {
  const { t } = useTranslate(["Product"]);

  return (
    <Stack direction="row" spacing={0.5} sx={{ flexWrap: "wrap", gap: 0.5 }}>
      <Chip
        size="small"
        label={`#${position}`}
        aria-label={t("Position {position}", { ns: "Product", position })}
      />
      {notRanking ? <NotRankingChip /> : null}
      {deleted ? (
        <Chip
          size="small"
          color="warning"
          variant="outlined"
          label={t("Deleted in the catalogue", { ns: "Product" })}
        />
      ) : null}
    </Stack>
  );
}

export function NotRankingChip() {
  const { t } = useTranslate(["Product"]);

  return (
    <Tooltip
      title={t(
        "Search no longer ranks this above the other results: it lies beyond the number of preferences that rank.",
        { ns: "Product" }
      )}
    >
      <Chip
        size="small"
        variant="outlined"
        sx={{ color: "grey.600" }}
        label={t("Does not rank", { ns: "Product" })}
      />
    </Tooltip>
  );
}
